export const MIN_PIXEL_TO_CLUSTERFY = 10; // Минимальное количество пикселов для кластеризации
export const MAP_BOUNDS_DEVIATION = 0.01; // Отклонение границ карты
